import React from 'react';
import { PageProps } from '../Page.types';
import AuthRedirect from '../AuthRedirect/AuthRedirect';

const Signup: React.FC<PageProps> = () => {
  return <AuthRedirect screenHint="signup" />;
};

export default Signup;
